import React from 'react';
import PropTypes from 'prop-types';

import { CITIZENSHIP, CITIZENSHIP_REVIEW } from 'config/formSections/citizenship';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { isFormSF852013, isPVQForm } from 'helpers/form';
import { isForeignBornUSCitizen } from '../../../../validators/passport';

import ConnectedUsPassport from '../UsPassport';
import ConnectedStatus from '../Status';
import ConnectedMultiple from '../Multiple';
import ConnectedPassports from '../Multiple/Passports';

const sectionConfig = {
  section: CITIZENSHIP.name,
  store: CITIZENSHIP.store,
  subsection: CITIZENSHIP_REVIEW.name,
};

export var Review = function (props) {
  const { requireCitizenshipForeignPassportsSection, formType, formVersion } = props;
  const subsectionProps = {
    required: true,
    scrollIntoView: false,
  };

  const sectionDivider = <hr className="section-divider" />;
  const isPVQ = isPVQForm(formType);

  return isPVQ ? (
    <div>
      <ConnectedUsPassport {...subsectionProps} />
      {sectionDivider}
      <ConnectedStatus {...subsectionProps} />
      {sectionDivider}
      <ConnectedMultiple {...subsectionProps} />
      {isForeignBornUSCitizen(props) && (
        <>
          {sectionDivider}
          <ConnectedUsPassport {...subsectionProps} />
        </>
      )}
      {requireCitizenshipForeignPassportsSection && (
        <>
          {sectionDivider}
          <ConnectedPassports {...subsectionProps} />
        </>
      )}
    </div>
  ) : (
    <div>
      {!isFormSF852013(formType, formVersion) && (
        <>
          <ConnectedUsPassport {...subsectionProps} />
          {sectionDivider}
        </>
      )}
      <ConnectedStatus {...subsectionProps} />
      {sectionDivider}
      <ConnectedMultiple {...subsectionProps} />
      {isFormSF852013(formType, formVersion) && isForeignBornUSCitizen(props) && (
        <>
          {sectionDivider}
          <ConnectedUsPassport {...subsectionProps} />
        </>
      )}
      {requireCitizenshipForeignPassportsSection && (
        <>
          {sectionDivider}
          <ConnectedPassports {...subsectionProps} />
        </>
      )}
    </div>
  );
};

Review.propTypes = {
  requireCitizenshipForeignPassportsSection: PropTypes.bool,
};

Review.defaultProps = {
  requireCitizenshipForeignPassportsSection: true,
};

export default connectSubsection(Review, sectionConfig);
